import { useState } from 'react';
import { swapsAPI } from '../utils/api';

const SwapRequestModal = ({ targetUser, currentUser, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    skillOffered: currentUser?.skillsOffered?.[0] || '',
    skillWanted: targetUser?.skillsOffered?.[0] || '',
    message: '',
    scheduledTime: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!form.skillOffered || !form.skillWanted) {
      setError('Please select both skills');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await swapsAPI.create({
        receiverId: targetUser._id,
        skillOffered: form.skillOffered,
        skillWanted: form.skillWanted,
        message: form.message,
        scheduledTime: form.scheduledTime || undefined
      });
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h3>Request Swap with {targetUser.name}</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {error && (
            <div style={{ background: '#fee2e2', color: '#991b1b', padding: '10px 14px', borderRadius: 8, fontSize: 13 }}>
              {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">I'll teach (my skill)</label>
            <select value={form.skillOffered} onChange={e => setForm({ ...form, skillOffered: e.target.value })}>
              <option value="">Select a skill you offer</option>
              {currentUser?.skillsOffered?.map((s, i) => <option key={i} value={s}>{s}</option>)}
              <option value="__custom">Other (type below)</option>
            </select>
            {form.skillOffered === '__custom' && (
              <input
                placeholder="Enter your skill"
                onChange={e => setForm({ ...form, skillOffered: e.target.value })}
                style={{ marginTop: 8 }}
              />
            )}
          </div>

          <div className="form-group">
            <label className="form-label">I want to learn (from {targetUser.name})</label>
            <select value={form.skillWanted} onChange={e => setForm({ ...form, skillWanted: e.target.value })}>
              <option value="">Select a skill you want</option>
              {targetUser?.skillsOffered?.map((s, i) => <option key={i} value={s}>{s}</option>)}
              <option value="__custom">Other (type below)</option>
            </select>
            {form.skillWanted === '__custom' && (
              <input
                placeholder="Enter skill you want"
                onChange={e => setForm({ ...form, skillWanted: e.target.value })}
                style={{ marginTop: 8 }}
              />
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Message (optional)</label>
            <textarea
              rows={3}
              placeholder="Introduce yourself and explain why you'd like to swap skills..."
              value={form.message}
              onChange={e => setForm({ ...form, message: e.target.value })}
              style={{ resize: 'vertical' }}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Proposed time (optional)</label>
            <input
              type="datetime-local"
              value={form.scheduledTime}
              onChange={e => setForm({ ...form, scheduledTime: e.target.value })}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
            {loading ? <><span className="loading-spinner" /> Sending...</> : 'Send Request'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SwapRequestModal;
